import { render, staticRenderFns } from "./ProductLinks.vue?vue&type=template&id=2547bf13&scoped=true&"
import script from "./ProductLinks.vue?vue&type=script&lang=js&"
export * from "./ProductLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547bf13",
  null
  
)

export default component.exports